(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-meta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mobile-collection-list-carousel')) {
    class MobileCollectionListCarousel extends HTMLElement {
      connectedCallback() {
        this.carousel = this.querySelector('scroll-carousel');
        this.interval = Number(this.getAttribute('interval')) || 3000;
        this.timer = null;
        this.isPaused = false;
        this.mediaQuery = window.matchMedia('(max-width: 699px)');
        this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onStateChange = this.update.bind(this);
        this.onPause = this.pause.bind(this);
        this.onResume = this.resume.bind(this);

        this.mediaQuery.addEventListener('change', this.onStateChange);
        this.reducedMotionQuery.addEventListener('change', this.onStateChange);
        document.addEventListener('visibilitychange', this.onStateChange);
        this.addEventListener('pointerenter', this.onPause);
        this.addEventListener('pointerleave', this.onResume);
        this.addEventListener('focusin', this.onPause);
        this.addEventListener('focusout', this.onResume);
        this.addEventListener('pointerdown', this.onPause);
        this.addEventListener('pointerup', this.onResume);
        this.addEventListener('pointercancel', this.onResume);

        customElements.whenDefined('scroll-carousel').then(() => {
          this.carousel = this.querySelector('scroll-carousel');
          this.update();
        });
      }

      disconnectedCallback() {
        this.stop();
        this.mediaQuery?.removeEventListener('change', this.onStateChange);
        this.reducedMotionQuery?.removeEventListener('change', this.onStateChange);
        document.removeEventListener('visibilitychange', this.onStateChange);
        this.removeEventListener('pointerenter', this.onPause);
        this.removeEventListener('pointerleave', this.onResume);
        this.removeEventListener('focusin', this.onPause);
        this.removeEventListener('focusout', this.onResume);
        this.removeEventListener('pointerdown', this.onPause);
        this.removeEventListener('pointerup', this.onResume);
        this.removeEventListener('pointercancel', this.onResume);
      }

      get canAutoscroll() {
        return this.hasAttribute('autoplay') && this.mediaQuery.matches && !this.reducedMotionQuery.matches && !document.hidden && this.carousel && Array.isArray(this.carousel.cells) && this.carousel.cells.length > this.carousel.groupCells;
      }

      update() {
        if (this.canAutoscroll && !this.isPaused) {
          this.start();
        } else {
          this.stop();
        }
      }

      start() {
        if (this.timer || !this.canAutoscroll) {
          return;
        }

        this.timer = setInterval(() => this.advance(), this.interval);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      pause() {
        this.isPaused = true;
        this.stop();
      }

      resume() {
        this.isPaused = false;
        this.update();
      }

      advance() {
        if (!this.canAutoscroll) {
          this.stop();
          return;
        }

        if (this.carousel.selectedIndex >= this.carousel.cells.length - this.carousel.groupCells) {
          this.carousel.select(0);
        } else {
          this.carousel.next();
        }
      }
    }

    customElements.define('mobile-collection-list-carousel', MobileCollectionListCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
